import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { IUser } from 'app/shared/model/user.model';

export interface IFavoriteTruck {
  id?: number;
  favorited?: boolean | null;
  user?: IUser | null;
  truckImplement?: ITruckImplement | null;
}

export const defaultValue: Readonly<IFavoriteTruck> = {
  favorited: false,
};
